  import React, { useEffect, useRef } from "react";
  import Layout from "./Layout";
  import useTableFunction from "../../../hooks/useTableFunction";
  import { COLLECTION, SESSION } from "../../../data/constant";
  import { db } from "../../../config/firebase";
  import { doc, getDoc,getDocs,where,query ,collection} from "firebase/firestore";


  // const fetchTransactionsByPhoneNumber = async (phoneNumber) => {
  //   try {
      
  //     const q = query(db, COLLECTION.TRANSACTIONS, where("phoneNumber", "==", (phoneNumber)));
    
  //     const querySnapshot = await getDocs(q);

  //     const transactionsData = [];

  //     querySnapshot.forEach((doc) => {
  //       transactionsData.push(doc.data());
  //     });

  //     return transactionsData;
  //   } catch (error) {
  //     console.error("Error fetching transactions:", error);
  //   }
  // };


  const UserTransaction = () => {

const dynamicConditionCB = async () => {
  try {
    let campus = "";

    const sessionId = localStorage.getItem(SESSION.CAMPUS_SESSION_ID);

    // Check if session ID exists
    if (!sessionId) {
      console.error("Campus session ID not found in local storage.");
      return null;
    }

    // Get document reference and fetch data
    const docRef = doc(db, COLLECTION.CAMPUS_SESSION, sessionId);
    const docSnap = await getDoc(docRef);

    // Check if the document exists
    if (docSnap.exists()) {
      const data = docSnap.data();
      campus = data?.campusId;

      const camdocRef = doc(db, COLLECTION.CAMPUS, campus);
      const camdocSnap = await getDoc(camdocRef);
      const camdata = camdocSnap.data();
      campus = camdata.campusId;

      console.log("Campus ID fetched:", campus);

      // Validate if campus ID is valid
      if (!campus) {
        console.error("Campus ID not found in the document.");
        return null;
      }

      // Step 2: Fetch users belonging to the campus
      const userCollectionRef = collection(db, COLLECTION.USER);
      const userQuery = query(userCollectionRef, where("campusName", "==", campus));
      const userSnapshots = await getDocs(userQuery);

      // Step 3: Extract phone numbers
      const phoneNumbers = [];
      userSnapshots.forEach((doc) => {
        const userData = doc.data();
        if (userData.phoneNumber) {
          phoneNumbers.push(userData.phoneNumber);
        }
      });

      console.log("User phone numbers:", phoneNumbers);

      // Check if we found any phone numbers
      if (phoneNumbers.length === 0) {
        console.error("No users found for the given campus.");
        return null;
      }

      // Return the dynamic condition with the list of phone numbers
      return {
        column: "phoneNumber",
        operator: "in",
        query: phoneNumbers,
      };
    } else {
      console.error("Campus session document does not exist.");
      return null;
    }
  } catch (error) {
    console.error("Error in dynamicConditionCB:", error.message);
    return null;
  }
};


const {
    tableData,
    isTableLoading,
    currentPage,
    totalLength,
    handlePageChange,
    handlePageSize,
    handleSearchQuery,
    handleTableSorting,
    refetchTableData,
  } = useTableFunction({
    collectionPath: COLLECTION.WALLET_DEDUCTIONS,
    dynamicCondition: dynamicConditionCB,  // Using the updated dynamic condition function
  });

    return (
     <Layout
      userTransactionData={tableData}
      isTableLoading={isTableLoading}
      currentPage={currentPage}
      totalLength={totalLength}
      handlePageChange={handlePageChange}
      handlePageSize={handlePageSize}
      handleSearchQuery={handleSearchQuery}
      handleTableSorting={handleTableSorting}
    />
    );
  };

  export default UserTransaction;
